<template>
  <div class="myCenterCommon__userContent__2fHEF undefined route-fade-enter-done">
    <div class="withdrawal__withdrawal__26MdO">
      <div>
        <div class="withdrawal__tobank__1OFti common__clearfix__28XIR">
          <div class="_myCenterTheme__tab__Ij1fV">
            <div class="myCenterCommon__users_layout__title__3CoQ0">
              <h3>取款</h3>
              <span>通常您的提款只需3 - 15分钟即可到账，若超过30分钟仍未到账，请联系在线客服核查</span>
            </div>
            <ul class="withdrawal__tabs__1Otai">
              <li @click="changqutype(0)" :class="qutype == 0 ? 'withdrawal__tab_active__1j07I' : ' '">银行卡取款</li>
              <li @click="changqutype(1)" :class="qutype == 1 ? 'withdrawal__tab_active__1j07I' : ' '"><span>USDT取款</span></li>
            </ul>
          </div>
          <div class="tabs_con" v-if="qutype == 0">
            <ul class="amountList__box__1_ZI4" style="width: 100%">
              <li>
                <img src="/static/image/sdqianbao.dc40ee4f3863c42e32b6a486b5b706fc.svg" class="amountList__icon__33WXt" />
                <div class="amountList__infoWrap__3hanq">
                  <span>中心钱包</span>
                  <div class="amountList__info__3_qtq">
                    <span class="amountList__amount__3uzil left_than">{{ $store.state.userInfo.balance }}</span
                    ><span class="amountList__rmb__2yHNG">元</span><img src="/static/image/shuaxin.6eaac0e1956ef2120631f454674d245a.svg" @click="$parent.getUserInfoShowLoding" class="amountList__refresh__3I1Qb" />
                  </div>
                </div>
              </li>
              <li>
                <img src="/static/image/zxqianbao.0949a0930bb15fa74de93288493d5fc9.svg" class="amountList__icon__33WXt" />
                <div class="amountList__infoWrap__3hanq">
                  <span>打码量</span>
                  <div class="amountList__info__3_qtq">
                    <span class="amountList__amount__3uzil">{{ betAmount }}</span
                    ><span class="amountList__rmb__2yHNG">元</span>
                  </div>
                </div>
              </li>
            </ul>
            <div style="margin-top: 50px"></div>
            <div class="userInfo__users_layout_form_item__35aDr" v-if="usercardLis.length > 0">
              <div class="userInfo__users_layout_form_label__2V7le">选择银行：</div>

              <el-select v-model="bankId" placeholder="请选择银行" @change="changApiType" style="width: 280px">
                <el-option :value="item.id" v-for="(item, index) in usercardLis" :key="index" :label="item.bank + '---' + item.bank_no"> </el-option>
              </el-select>
              <div class="xieyi2" v-if="usercardLis.length < 5" style="width: 133px; color: red; cursor: pointer; height: 40px; margin: 0px 0px 0px 20px" @click="changBindShow(1)">新增绑定</div>
            </div>
            <div class="userInfo__users_layout_form_item__35aDr">
              <div class="userInfo__users_layout_form_label__2V7le">取款金额：</div>
              <div class="userInfo__users_layout_form_input__2D3z3" style=""><input v-model="amount" type="text" data-analytics="button" data-label="" placeholder="取款金额" value="" class="index__Input__tY5CA" style="width: 280px; height: 40px" /></div>
            </div>
            <div class="userInfo__users_layout_form_item__35aDr" style="">
              <div class="userInfo__users_layout_form_label__2V7le">取款密码：</div>
              <div class="userInfo__users_layout_form_input__2D3z3"><input v-model="password" type="password"  autocomplete="new-password" data-analytics="button" data-label="" placeholder="取款资金密码" value="" class="index__Input__tY5CA" style="width: 280px; height: 40px" /></div>
            </div>
            <div v-if="usercardLis.length == 0">
              <p class="withdrawal__tip__2YpMI" style="margin-top: 20px">选择银行</p>
              <div class="style__list_box__2YvIs cunkuan1" style="display: block">
                <ul class="withdrawal__bankList__3K4iO withdrawal__usdt__2WQ_o">
                  <li class="withdrawal__addBankButton__2mx2m" @click="changBindShow(1)"><img src="/static/image/tianjia.5395050f231e402684eb5cd3a300729a.svg" />添加银行卡</li>
                </ul>
              </div>
              <div class="withdrawal__tisi__25TqN undefined" style="margin-bottom: 33px"><img src="/static/image/tisi.8d134098e1e18d283c7886fb98257f6d.svg" />您还没绑定银行卡，为了您的资金安全，绑定银行卡时，需要填写您的个人信</div>
            </div>
            <button @click="withdraw" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 440px; height: 50px; margin: 20px auto; display: block">立即取款</button>
          </div>
          <div class="tabs_con" v-if="qutype == 1">
                <ul class="amountList__box__1_ZI4" style="width: 100%">
              <li>
                <img src="/static/image/sdqianbao.dc40ee4f3863c42e32b6a486b5b706fc.svg" class="amountList__icon__33WXt" />
                <div class="amountList__infoWrap__3hanq">
                  <span>中心钱包</span>
                  <div class="amountList__info__3_qtq">
                    <span class="amountList__amount__3uzil left_than">{{ $store.state.userInfo.balance }}</span
                    ><span class="amountList__rmb__2yHNG">元</span><img src="/static/image/shuaxin.6eaac0e1956ef2120631f454674d245a.svg" @click="$parent.getUserInfoShowLoding" class="amountList__refresh__3I1Qb" />
                  </div>
                </div>
              </li>
              <li>
                <img src="/static/image/zxqianbao.0949a0930bb15fa74de93288493d5fc9.svg" class="amountList__icon__33WXt" />
                <div class="amountList__infoWrap__3hanq">
                  <span>打码量</span>
                  <div class="amountList__info__3_qtq">
                    <span class="amountList__amount__3uzil">{{ betAmount }}</span
                    ><span class="amountList__rmb__2yHNG">元</span>
                  </div>
                </div>
              </li>
            </ul>
            <div style="margin-top: 50px"></div>
            <div class="userInfo__users_layout_form_item__35aDr" v-if="usdssLis.length > 0">
              <div class="userInfo__users_layout_form_label__2V7le">USDT地址：</div>

              <el-select v-model="bankId" placeholder="请选择USDT地址" @change="changApiType" style="width: 280px">
                <el-option :value="item.id" v-for="(item, index) in usdssLis" :key="index" :label="item.bank_owner + '---' + item.bank_no"> </el-option>
              </el-select>
              <div class="xieyi2" @click="changBindShow(2)" v-if="usdssLis.length < 5" style="width: 133px; color: red; cursor: pointer; height: 40px; margin: 0px 0px 0px 20px">新增绑定</div>
            </div>

            <div class="userInfo__users_layout_form_item__35aDr" style="">
              <div class="userInfo__users_layout_form_label__2V7le">取款金额：</div>
              <div class="userInfo__users_layout_form_input__2D3z3"><input v-model="amount" type="text" data-analytics="button" data-label="" placeholder="取款金额" value="" class="index__Input__tY5CA" style="width: 280px; height: 40px" /></div>
            </div>
            <div class="userInfo__users_layout_form_item__35aDr" style="">
              <div class="userInfo__users_layout_form_label__2V7le">取款密码：</div>
              <div class="userInfo__users_layout_form_input__2D3z3" style=""><input v-model="password" type="password" data-analytics="button"  autocomplete="new-password" data-label="" placeholder="取款资金密码" value="" class="index__Input__tY5CA" style="width: 280px; height: 40px" /></div>
            </div>
            <div class="userInfo__users_layout_form_item__35aDr" style="" v-if="chanmeyXi">
              <div class="userInfo__users_layout_form_label__2V7le">每笔手续费：</div>
              <div class="userInfo__users_layout_form_input__2D3z3">
                <div class="style__tk_ts__302_r">
                  <span class="usdt">{{ chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee : $store.state.userInfo.withdrawfeeusdttrc }}</span> USDT
                </div>
              </div>
            </div>
            <div class="userInfo__users_layout_form_item__35aDr">
              <div class="userInfo__users_layout_form_label__2V7le">USDT换算：</div>
              <div class="userInfo__users_layout_form_input__2D3z3">
                <div class="style__tk_ts__302_r">
                  ≈<span class="usdt">{{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 : '0.00' }}</span> USDT &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ $store.state.userInfo.withdrawusdtrate }}
                </div>
              </div>
            </div>
            <div class="userInfo__users_layout_form_item__35aDr">
              <div class="userInfo__users_layout_form_label__2V7le">实际到账：</div>
              <div class="userInfo__users_layout_form_input__2D3z3">
                <div class="style__tk_ts__302_r">
                  <span class="usdt" style="color: red">{{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 - (chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee * 1 : $store.state.userInfo.withdrawfeeusdttrc * 1) : '0.00' }} </span> USDT
                </div>
                <input type="hidden" id="usdt_rate" value="6.56" />
              </div>
            </div>
            <div v-if="usdssLis.length == 0">
              <p class="withdrawal__tip__2YpMI" style="margin-top: 50px">选择USDT地址</p>
              <div class="style__list_box__2YvIs cunkuan1" style="display: block">
                <ul class="withdrawal__bankList__3K4iO withdrawal__usdt__2WQ_o">
                  <li class="withdrawal__addBankButton__2mx2m" @click="changBindShow(2)"><img src="/static/image/tianjia.5395050f231e402684eb5cd3a300729a.svg" />添加地址</li>
                </ul>
              </div>
              <div class="withdrawal__tisi__25TqN undefined" style="margin-bottom: 33px"><img src="/static/image/tisi.8d134098e1e18d283c7886fb98257f6d.svg" />您还没绑定钱包地址，为了您的资金安全，请仔细填写</div>
            </div>

            <button @click="withdraw1" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 440px; height: 50px; margin: 10px auto; display: block">立即取款</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加银行 -->
    <div class="el-dialog__wrapper" style="z-index: 999; background: rgb(81 73 73 / 49%)" @click="changBindShow(0)" v-if="bindShow == 1">
      <div role="dialog" aria-modal="true" aria-label="绑定银行卡" class="el-dialog" style="margin-top: 15vh" @click="retrun">
        <div class="el-dialog__header">
          <span class="el-dialog__title">绑定银行卡</span><button type="button" @click="changBindShow(0)" aria-label="Close" class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
        </div>
        <div class="el-dialog__body">
          <div class="el-form el-form--inline">
            <div class="el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank" class="el-form-item__label" style="width: 150px">请选择支持银行</label>
                <el-select v-model="cardInfo.bank" placeholder="请选择支持银行" style="width: 380px">
                  <el-option v-for="item in banklist" :key="item.bank_name" :label="item.bank_name" :value="item.bank_name"> </el-option>
                </el-select>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">填写开户行</label>
                <div class="el-form-item__content" style="width: 380px">
                  <div class="el-input"><input type="text" v-model="cardInfo.bank_address" autocomplete="off" placeholder="请输入开户行" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">填写卡号</label>
                <div class="el-form-item__content" style="width: 380px">
                  <div class="el-input"><input type="text" v-model="cardInfo.bank_no" autocomplete="off" placeholder="填写卡号" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">填写持卡人姓名</label>
                <div class="el-form-item__content" style="width: 380px">
                  <div class="el-input"><input type="text" v-model="cardInfo.bank_owner" autocomplete="off" placeholder="填写持卡人姓名" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">支付密码</label>
                <div class="el-form-item__content">
                  <div class="el-input" style="width: 380px"><input type="password" v-model="cardInfo.pay_pass" autocomplete="new-password" placeholder="支付密码" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px; padding-left: 150px">
              <button type="button" class="el-button el-button--primary" @click="bindCard"><span>绑定</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加USDT -->
    <div class="el-dialog__wrapper" style="z-index: 999; background: rgb(81 73 73 / 49%)" @click="changBindShow(0)" v-if="bindShow == 2">
      <div role="dialog" aria-modal="true" aria-label="绑定USDT地址" class="el-dialog" style="margin-top: 15vh" @click="retrun">
        <div class="el-dialog__header">
          <span class="el-dialog__title">绑定USDT地址</span><button type="button" aria-label="Close" @click="changBindShow(0)" class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
        </div>
        <div class="el-dialog__body">
          <div class="el-form el-form--inline">
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">USDT地址</label>
                <div class="el-form-item__content">
                  <div class="el-input" style="width: 380px"><input type="text" v-model="usdtInfo.bank_no" autocomplete="off" placeholder="绑定USDT地址" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">USDT协议</label>
                <div class="el-form-item__content">
                  <el-radio v-model="usdtInfo.bank_owner" label="ERC20">ERC20</el-radio>
                  <el-radio v-model="usdtInfo.bank_owner" label="TRC20">TRC20</el-radio>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">支付密码</label>
                <div class="el-form-item__content">
                  <div class="el-input" style="width: 380px"><input type="password" v-model="usdtInfo.pay_pass" autocomplete="new-password" placeholder="支付密码" class="el-input__inner" /></div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px; padding-left: 150px">
              <button type="button" class="el-button el-button--primary" @click="bindUsdss"><span>绑定</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'withdraw',
  data() {
    return {
      qutype: 0,
      amount: null,
      bankId: null,
      chanmeyXi: null,
      usercardLis: [],
      usdssLis: [],
      banklist: [],
      cardInfo: {},
      usdtInfo: {},
      password: null,
      bindShow: 0,
      betAmount: null,
    };
  },
  created() {
    let that = this;
    that.getBetAmount();

    that.getUsercard();
    that.getUsdssList();
    that.getBanklist();
  },
  methods: {
    getBetAmount() {
      let that = this;
      that.$apiFun
        .post('/api/getBetAmount', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.betAmount = res.data.bet_amount;
          }
        })
        .catch(res => {});
    },
    retrun(event) {
      event.stopPropagation();
    },
    closeCv() {
      let that = this;
      that.openInfo = {};
      that.amount = null;
    },
    changApiType(e) {
      let that = this;
      if (that.qutype == 1) {
        let chanmeyXi = null;
        that.usdssLis.forEach(el => {
          if (el.id == e) {
            chanmeyXi = el.bank_owner;
            return;
          }
        });
        that.chanmeyXi = chanmeyXi;
      } else {
        that.chanmeyXi = null;
      }

      that.password = null;
      that.amount = null;
    },
    changBindShow(type) {
      let that = this;
      that.bindShow = type;
      that.cardInfo = {};
      that.usdtInfo = {};
    },
    bindUsdss() {
      let that = this;
      let usdtInfo = that.usdtInfo;
      usdtInfo.bank = 'USDT';
      if (usdtInfo.bank_no == null || usdtInfo.bank_no == '') {
        that.$parent.showTost(0, '请输入USDT地址');
        return;
      }
      if (!usdtInfo.bank_owner || usdtInfo.bank_owner == null) {
        that.$parent.showTost(0, '请选择钱包协议');
        return;
      }
      if (!usdtInfo.pay_pass) {
        that.$parent.showTost(0, '请输人支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', usdtInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, res.message);
            that.changBindShow(0);
            that.getUsercard();
            that.getUsdssList();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    bindCard() {
      let that = this;
      if (!that.cardInfo.bank_owner) {
        that.$parent.showTost(0, '请输入姓名');
        return;
      }
      if (!that.cardInfo.bank) {
        that.$parent.showTost(0, '请输入银行');
        return;
      }
      if (!that.cardInfo.bank_address) {
        that.$parent.showTost(0, '请输入开户行地址');
        return;
      }
      if (!that.cardInfo.bank_no) {
        that.$parent.showTost(0, '请输人银行卡号');
        return;
      }
      if (!that.cardInfo.pay_pass) {
        that.$parent.showTost(0, '请输人支付密码');
        return;
      }
      if (that.cardInfo.bank_no.length < 8) {
        that.$parent.showTost(0, '请输人正确的卡号长度');
        return;
      }
      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输人支付密码长度');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', that.cardInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
          }
          that.changBindShow(0);
          that.getUsercard();
          that.getUsdssList();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changqutype(val) {
      let that = this;
      if (that.qutype == val) {
        return;
      }
      that.qutype = val;
      that.amount = null;
      that.password = null;
      that.bankId = null;
      that.chanmeyXi = null;
    },
    getUsercard() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.usercardLis = res.data;
        }
      });
    },
    getUsdssList() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
      });
    },
    withdraw() {
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.showTost(0, '请选择您要提现到的银行卡');
        return;
      }
      if (amount < 100) {
        that.showTost(0, '单笔取款不能低于100元');
        return;
      }

      if (!password) {
        that.showTost(0, '请输入您的支付密码');
        return;
      }
      that.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, '提交成功，等待后台审核');

            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 1500);
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    withdraw1() {
      let that = this;
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.showTost(0, '请选择USDT地址');
        return;
      }
      if (amount < 100) {
        that.showTost(0, '单笔取款不能低于100元');
        return;
      }

      if (!password) {
        that.showTost(0, '请输入您的支付密码');
        return;
      }
      that.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, '提交成功，等待后台审核');
            that.chanmeyXi = null;
            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 1500);
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/Withdrawal_81ba8019.09592551.css';
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';
</style>



// WEBPACK FOOTER //
// src/components/mine/withdraw.vue